import Backend from 'i18next-xhr-backend'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { en, es } from '../../locales/index'
import { getLangValue } from './helpers'
import { initReactI18next } from 'react-i18next'
import { LANGS_AVAILABLE } from './constants'
import { LOCAL_STORAGE_I18N_VAR_NAME } from '../../src/utils/constants'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localstorage'],
      lookupLocalStorage: LOCAL_STORAGE_I18N_VAR_NAME,
      caches: ['localStorage']
    },
    resources: {
      en: { translation: en[LANGS_AVAILABLE[1].value] },
      es: { translation: es[LANGS_AVAILABLE[0].value] }
    },
    fallbackLng: getLangValue(),
    debug: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false }
  })

export default i18n
